import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';
import path from 'utils/path';

export const routerPath = {
  root: '/user-referral-report',
  link: `/reports/user-referral-report`,
  usersUsedCode: ({ id, ownerName, from, to }) =>
    path(
      id,
      `/user-used-code?ownerName=${ownerName}&from=${from ? new Date(from).toUTCString() : ''}&to=${
        to ? new Date(to).toUTCString() : ''
      }`
    ),
};

export const getColumns = ({ goUserUsedCode }) => [
  {
    id: 'ownerName',
    label: 'Owner Name',
    align: 'left',
    nameForSort: 'owner_name',
  },
  {
    id: 'ownerSurname',
    label: 'Owner Surname',
    align: 'left',
    nameForSort: 'owner_surname',
  },
  { id: 'voucherValue', label: 'Referral code', align: 'center', nameForSort: 'voucher_value' },
  {
    id: 'codesUsed',
    label: 'Codes used',
    align: 'center',
    nameForSort: 'codes_used',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      {
        id: 1,
        name: 'Users',
        action: goUserUsedCode,
        icon: 'mdi:text-box-multiple-outline',
      },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ region, searchByText, dateRange, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by owner name and code...',
    action: searchByText.change,
    defaultValue: searchByText.defaultValue,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
